import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';

export const MultiContainsMatcher: FieldMatcher = {
  name: 'multiContains',
  displayName: 'Contains',
  hasEditor: true,
  options: {
    chipFormatter: (value: string): string => {
      try {
        const values: string[] = JSON.parse(value);
        if (values.length === 0) return '';
        if (values.length === 1) return `: ${values[0]}`;
        return `: ${values[0]} +${values.length - 1} more`;
      } catch {
        return `: ${value}`;
      }
    },
  },
};
